
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  OrganizationDetailsResource,
  OrganizationDetailsUpdateRequest,
  OrganizationDomainsResource,
} from '../models';
import {
    OrganizationDetailsResourceFromJSON,
    OrganizationDetailsResourceToJSON,
    OrganizationDetailsUpdateRequestFromJSON,
    OrganizationDetailsUpdateRequestToJSON,
    OrganizationDomainsResourceFromJSON,
    OrganizationDomainsResourceToJSON,
} from '../models';

export interface GetOrganizationDetailsRequest {
    organizationId: string;
}

export interface GetOrganizationEmailDomainsRequest {
    organizationId: string;
}

export interface UpdateOrganizationDetailsRequest {
    organizationId: string;
    organizationDetailsUpdateRequest: OrganizationDetailsUpdateRequest;
}

export interface UploadOrganizationLogoRequest {
    organizationId: string;
    file: Blob;
}

/**
 * 
 */
export class OrganizationDetailsApi extends runtime.BaseAPI {

    /**
     * Get organization details
          */
    async getOrganizationDetailsRaw(requestParameters: GetOrganizationDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<OrganizationDetailsResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getOrganizationDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<OrganizationDetailsResource>({
            path: `/client-settings/api/organizations/{organizationId}/details`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=OrganizationDetailsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get organization details
          */
    async getOrganizationDetails(organizationId: string, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<OrganizationDetailsResource> {
        const response = await this.getOrganizationDetailsRaw({ organizationId: organizationId }, initOverrides);
        return response._data;
    }

    /**
     * Get organization email domains 
     * Get organization email domains
          */
    async getOrganizationEmailDomainsRaw(requestParameters: GetOrganizationEmailDomainsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<OrganizationDomainsResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling getOrganizationEmailDomains().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<OrganizationDomainsResource>({
            path: `/client-settings/api/organizations/{organizationId}/email-domains`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=OrganizationDomainsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get organization email domains 
     * Get organization email domains
          */
    async getOrganizationEmailDomains(organizationId: string, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<OrganizationDomainsResource> {
        const response = await this.getOrganizationEmailDomainsRaw({ organizationId: organizationId }, initOverrides);
        return response._data;
    }

    /**
     * Update organization details
          */
    async updateOrganizationDetailsRaw(requestParameters: UpdateOrganizationDetailsRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<OrganizationDetailsResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling updateOrganizationDetails().'
            );
        }

        if (requestParameters['organizationDetailsUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'organizationDetailsUpdateRequest',
                'Required parameter "organizationDetailsUpdateRequest" was null or undefined when calling updateOrganizationDetails().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<OrganizationDetailsResource>({
            path: `/client-settings/api/organizations/{organizationId}/details`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: OrganizationDetailsUpdateRequestToJSON(requestParameters['organizationDetailsUpdateRequest']),
        }, initOverrides);

        if (response._data) { response._data=OrganizationDetailsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Update organization details
          */
    async updateOrganizationDetails(organizationId: string, organizationDetailsUpdateRequest: OrganizationDetailsUpdateRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<OrganizationDetailsResource> {
        const response = await this.updateOrganizationDetailsRaw({ organizationId: organizationId, organizationDetailsUpdateRequest: organizationDetailsUpdateRequest }, initOverrides);
        return response._data;
    }

    /**
     * Upload organization logo
          */
    async uploadOrganizationLogoRaw(requestParameters: UploadOrganizationLogoRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<OrganizationDetailsResource>> {
        if (requestParameters['organizationId'] == null) {
            throw new runtime.RequiredError(
                'organizationId',
                'Required parameter "organizationId" was null or undefined when calling uploadOrganizationLogo().'
            );
        }

        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling uploadOrganizationLogo().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        const response = await this.request<OrganizationDetailsResource>({
            path: `/client-settings/api/organizations/{organizationId}/logo`.replace(`{${"organizationId"}}`, encodeURIComponent(String(requestParameters['organizationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=OrganizationDetailsResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Upload organization logo
          */
    async uploadOrganizationLogo(organizationId: string, file: Blob, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<OrganizationDetailsResource> {
        const response = await this.uploadOrganizationLogoRaw({ organizationId: organizationId, file: file }, initOverrides);
        return response._data;
    }

}
